module.exports = __webpack_public_path__ + "assets/media/user-member-lovel05.e8f13f80.png";